import { createContext } from 'react';

import type { HoneycombChartProperties } from '../types/honeycomb-config-properties.js';

/**
 * @internal
 */
export const HoneycombChartConfigContext = createContext<
  HoneycombChartProperties | string
>({});

/**
 * Provider for the HoneycombChart API config that can be shared across charts
 * @public
 */
export const HoneycombChartConfig = HoneycombChartConfigContext.Provider;
